import React from 'react';
import Navbar from '../../components/Navbar/Navbar';
import Sidebar from '../../components/Sidebar/Sidebar';
import { useNavigate } from 'react-router-dom';
import { useGlobalContext } from '../../context/Context';
import { FaChevronLeft } from 'react-icons/fa';
import { useState } from 'react';
import axios from 'axios';
import { useEffect } from 'react';
import Loader from '../../components/Loader/Loader';
import 'react-loading-skeleton/dist/skeleton.css';
import {
  CreateAffiliate,
  DeleteAffiliates,
  UpdateAffiliate,
} from '../../components/Modals/Modals';
import { toast } from 'react-toastify';

const Affiliates = () => {
  const navigate = useNavigate();
  const { showProfileModal, baseURL } = useGlobalContext();
  const [loading, setLoading] = useState(true);
  const [updateAffiliate, setUpdateAffiliate] = useState(false);
  const [affiliateId, setAffiliateId] = useState(``);
  const [createAffiliate, setCreateAffiliate] = useState(false);
  const [deleteAffiliates, setDeleteAffiliates] = useState(false);
  const [affiliates, setAffiliates] = useState([]);
  const { token } = JSON.parse(sessionStorage.getItem(`adminData`));

  //   GET ALL AFFILIATES
  const getAffiliates = async () => {
    try {
      setLoading(true);
      const { data } = await axios.get(`${baseURL}/affiliates`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setAffiliates(data.affiliates);
      setLoading(false);
    } catch (error) {
      setLoading(false);
    }
  };

  useEffect(() => {
    getAffiliates();
    // eslint-disable-next-line
  }, [updateAffiliate]);

  const deleteAffiliate = async (id) => {
    try {
      const { data } = await axios.delete(`${baseURL}/affiliates/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      toast.success(data.msg);
      getAffiliates();
    } catch (error) {
      toast.error(error.response.data.msg);
    }
  };

  return (
    <main className='affiliates-page'>
      <Navbar category={`Management >`} currentPage={`Affiliates`} />
      <Sidebar activePage={15} />

      <div className={`main-content ${showProfileModal ? `back` : null}`}>
        <div className='links-btn'>
          <FaChevronLeft onClick={() => navigate(`/dashboard`)} />
          <h2 className='title'>Affiliates</h2>
        </div>

        <div className='create-del-btns'>
          <button className='primary' onClick={() => setCreateAffiliate(true)}>
            Create Affiliate
          </button>
          <button className='red' onClick={() => setDeleteAffiliates(true)}>
            Delete All Affiliates
          </button>
        </div>

        {loading ? (
          <div className='loader-container'>
            <Loader />
          </div>
        ) : (
          <>
            {affiliates.map((affiliate, affiliateIndex) => {
              const { link, image, caption, _id } = affiliate;
              return (
                <div className='link-details' key={affiliateIndex}>
                  <h3 className='title'>
                    Affiliate {affiliateIndex + 1} Details
                  </h3>
                  <div className='form-control'>
                    <label htmlFor=''>Affiliate Link</label>
                    <h3>{link}</h3>
                  </div>
                  <div className='form-control'>
                    <label htmlFor=''>Affiliate Caption</label>
                    <h3>{caption}</h3>
                  </div>
                  <div className='form-control'>
                    <label htmlFor=''>Affiliate Image</label>
                    <div className='img'>
                      <img
                        src={`https://api.crspredictions.com${image}`}
                        alt=''
                      />
                    </div>
                  </div>
                  <div className='btns'>
                    <button
                      className='primary'
                      onClick={() => {
                        setAffiliateId(_id);
                        setUpdateAffiliate(true);
                      }}
                    >
                      Update Affiliate
                    </button>
                    <button
                      className='red'
                      onClick={() => {
                        deleteAffiliate(_id);
                      }}
                    >
                      Delete Affiliate
                    </button>
                  </div>
                </div>
              );
            })}
          </>
        )}
      </div>
      {createAffiliate && (
        <CreateAffiliate
          dismissFunc={setCreateAffiliate}
          refreshFunc={getAffiliates}
        />
      )}
      {updateAffiliate && (
        <UpdateAffiliate
          affiliateId={affiliateId}
          dismissFunc={setUpdateAffiliate}
        />
      )}
      {deleteAffiliates && (
        <DeleteAffiliates
          dismissFunc={setDeleteAffiliates}
          refreshFunc={getAffiliates}
        />
      )}
    </main>
  );
};

export default Affiliates;
